import { BaseRequest, BaseResponse } from '../models'
import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { UserTemporaryCode } from '../../models/UserTemporaryCode'

const _BASE_URL = import.meta.env.REACT_APP_IAM_API_BASE_URL!

export interface GetUserTemporaryCodeRequest extends BaseRequest {
  type: string
  body?: { [key: string]: any }
}

export const userTemporaryCodeApi = createApi({
  reducerPath: 'userTemporaryCodeApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  tagTypes: ['userTemporaryCodes'],
  endpoints: (builder) => ({
    getUserTemporaryCode: builder.mutation<BaseResponse<UserTemporaryCode>, GetUserTemporaryCodeRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/user-temporary-codes/types/${request.type}/codes`,
        method: 'POST',
        body: request.body,
      }),
    }),
  }),
})

export const { useGetUserTemporaryCodeMutation } = userTemporaryCodeApi
